var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnChatbotPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10733_93119)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10733_93119)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 25,
    fill: "#172664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.4109 12.5254C29.9018 12.5255 31.1101 13.7346 31.1101 15.2256C31.1099 16.3642 30.4043 17.3358 29.407 17.7324V19.0273H35.739C39.1335 19.0273 41.6277 22.189 41.6277 25.7461V33.0244C41.6276 36.5804 39.1334 39.7412 35.739 39.7412H28.615L21.4753 42.8643C21.1662 42.9994 20.8095 42.9689 20.5271 42.7842C20.2448 42.5994 20.075 42.2847 20.075 41.9473V39.6455C17.2019 39.0966 15.1863 36.221 15.1863 33.0244V25.7441C15.1865 22.1896 17.6801 19.0296 21.074 19.0293L27.407 19.0273V17.7295C26.4136 17.331 25.7109 16.3614 25.7107 15.2256C25.7107 13.7346 26.9199 12.5254 28.4109 12.5254ZM21.075 21.0293C19.0678 21.0293 17.1865 22.9886 17.1863 25.7441V33.0244C17.1863 35.7815 19.0679 37.7412 21.075 37.7412C21.627 37.7414 22.075 38.1891 22.075 38.7412V40.418L28.0066 37.8252L28.1023 37.7881C28.2005 37.7567 28.3035 37.7412 28.407 37.7412H35.739C37.7461 37.7412 39.6276 35.7815 39.6277 33.0244V25.7461C39.6277 22.9876 37.746 21.0273 35.739 21.0273L21.075 21.0293ZM25.2214 32.9131C25.5523 32.4712 26.1797 32.3814 26.6218 32.7119C27.1369 33.0973 27.7628 33.3065 28.406 33.3076C29.0498 33.3068 29.6767 33.0976 30.1921 32.7119C30.6341 32.3815 31.2606 32.4715 31.5916 32.9131C31.9224 33.3552 31.8324 33.9825 31.3904 34.3135C30.5296 34.9576 29.4831 35.3064 28.408 35.3076H28.405C27.33 35.3063 26.2833 34.9576 25.4226 34.3135C24.9809 33.9825 24.8907 33.3551 25.2214 32.9131ZM23.8162 24.251C24.806 24.2512 25.6082 25.054 25.6082 26.0439V28.0781C25.6082 29.0681 24.806 29.8708 23.8162 29.8711C22.8261 29.8711 22.0232 29.0682 22.0232 28.0781V26.0439C22.0232 25.0538 22.8261 24.251 23.8162 24.251ZM32.9978 24.251C33.9879 24.251 34.7908 25.0538 34.7908 26.0439V28.0781C34.7908 29.0682 33.9879 29.8711 32.9978 29.8711C32.0077 29.8711 31.2048 29.0682 31.2048 28.0781V26.0439C31.2048 25.0538 32.0077 24.251 32.9978 24.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5724 41.269C49.5722 44.0302 46.9938 46.2686 43.8138 46.2686H29.0704C25.8904 46.2686 23.312 44.0302 23.3118 41.269C23.3118 38.5075 25.8902 36.2686 29.0704 36.2686H43.8138C46.994 36.2686 49.5724 38.5075 49.5724 41.269Z",
    fill: "#5F6267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5995 43.6121L42.7039 40.2432H43.6278L44.1369 42.7416H44.1558L44.7529 40.2432H45.6328L46.2331 42.7416H46.2519L46.7642 40.2432H47.6693L46.7768 43.6121H45.7994L45.1897 41.23H45.1709L44.5643 43.6121H43.5995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0413 43.682C40.0105 43.682 39.3851 43.0126 39.3851 41.9347V41.9316C39.3851 40.8599 40.0168 40.1748 41.0036 40.1748C41.9904 40.1748 42.6095 40.8442 42.6095 41.8624V42.1453H40.2902C40.2997 42.6827 40.5919 42.9969 41.0602 42.9969C41.4373 42.9969 41.6667 42.7895 41.7327 42.6009L41.739 42.5821H42.5812L42.5718 42.6167C42.4681 43.1132 42.003 43.682 41.0413 43.682ZM41.0193 40.8599C40.6422 40.8599 40.3594 41.1113 40.2997 41.567H41.7296C41.673 41.1019 41.3996 40.8599 41.0193 40.8599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5615 39.8099C38.285 39.8099 38.0713 39.593 38.0713 39.3322C38.0713 39.0713 38.285 38.8545 38.5615 38.8545C38.8381 38.8545 39.0518 39.0713 39.0518 39.3322C39.0518 39.593 38.8381 39.8099 38.5615 39.8099ZM38.1027 43.6125V40.2436H39.0204V43.6125H38.1027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7016 43.6121L34.5356 40.2432H35.5162L36.2201 42.8013H36.239L36.9335 40.2432H37.892L36.7355 43.6121H35.7016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.024 43.682C31.9932 43.682 31.3678 43.0126 31.3678 41.9347V41.9316C31.3678 40.8599 31.9995 40.1748 32.9863 40.1748C33.9731 40.1748 34.5922 40.8442 34.5922 41.8624V42.1453H32.2729C32.2823 42.6827 32.5746 42.9969 33.0428 42.9969C33.42 42.9969 33.6494 42.7895 33.7154 42.6009L33.7217 42.5821H34.5639L34.5545 42.6167C34.4508 43.1132 33.9856 43.682 33.024 43.682ZM33.002 40.8599C32.6249 40.8599 32.342 41.1113 32.2823 41.567H33.7122C33.6557 41.1019 33.3823 40.8599 33.002 40.8599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3815 43.6129V40.2439H30.2991V40.8316H30.318C30.4186 40.4168 30.692 40.1748 31.0848 40.1748C31.1854 40.1748 31.2796 40.1905 31.3488 40.2094V41.017C31.2734 40.9856 31.1477 40.9668 31.0157 40.9668C30.5631 40.9668 30.2991 41.237 30.2991 41.7273V43.6129H29.3815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6101 43.612V39.0771H27.4329C28.3882 39.0771 29.0262 39.6931 29.0262 40.6265V40.6328C29.0262 41.5661 28.3882 42.1821 27.4329 42.1821H26.5592V43.612H25.6101ZM27.2003 39.8282H26.5592V41.4404H27.2003C27.744 41.4404 28.0645 41.1513 28.0645 40.6359V40.6296C28.0645 40.1142 27.744 39.8282 27.2003 39.8282Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10733_93119",
    x: 2.5,
    y: 2.5,
    width: 59,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10733_93119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10733_93119",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10733_93119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnChatbotPreview);
export default __webpack_public_path__ + "static/media/icn_chatbot_preview.1b2b9c4b53104258f3638f0ac9c8a9ad.svg";
export { ForwardRef as ReactComponent };